exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".print-container[data-v-22a6670e]{position:relative}.print-container .card[data-v-22a6670e]{margin-bottom:1.5rem}.print-container .card .card-header[data-v-22a6670e]{color:#fff;font-size:.95rem!important;padding:.1rem 1rem}.print-container .table td[data-v-22a6670e],.print-container .table th[data-v-22a6670e]{font-size:.95rem;padding:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22a6670e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Orders/Import/PrintingProcess.vue
// module id = hKbO
// module chunks = 1